export interface CpmTabBarTab {
    value: string;
    label: string;
    count?: number;
}

interface CpmTabBarProps {
    tabs: CpmTabBarTab[];
    value: string;
    onChange: (value: string) => void;
    className?: string;
}

/**
 * In-card tab row — underline style (3px navy-purple rule under the active
 * label), matches the design system's `TabBar` component exactly (see docs2
 * `_ds_bundle.js`). Meant to live as the first row inside a `CpmCard`.
 */
export default function CpmTabBar({ tabs, value, onChange, className = '' }: CpmTabBarProps) {
    return (
        <div
            className={['flex items-center justify-between flex-wrap', className].join(' ')}
            style={{
                gap: 20,
                padding: '0 20px',
                borderBottom: '1px solid var(--cpm-border-default)',
            }}
        >
            <div className="flex items-stretch" style={{ gap: 4 }}>
                {tabs.map((tab) => {
                    const active = tab.value === value;
                    return (
                        <button
                            key={tab.value}
                            type="button"
                            onClick={() => onChange(tab.value)}
                            className="flex items-center bg-transparent border-0 cursor-pointer"
                            style={{
                                gap: 9,
                                padding: '18px 14px 15px',
                                borderBottom: `3px solid ${
                                    active ? 'var(--cpm-brand-purple)' : 'transparent'
                                }`,
                                marginBottom: -1,
                                fontFamily: 'var(--cpm-font-sans)',
                                fontSize: 14,
                                fontWeight: 800,
                                color: active
                                    ? 'var(--cpm-brand-navy)'
                                    : 'var(--cpm-text-secondary)',
                            }}
                        >
                            {tab.label}
                            {tab.count != null ? (
                                <span
                                    style={{
                                        padding: '3px 9px',
                                        borderRadius: 'var(--cpm-radius-full)',
                                        background: active
                                            ? 'var(--cpm-purple-tint-13)'
                                            : 'var(--cpm-surface-subtle)',
                                        color: active
                                            ? 'var(--cpm-brand-purple)'
                                            : 'var(--cpm-text-secondary)',
                                        fontSize: 11,
                                        fontWeight: 800,
                                        fontVariantNumeric: 'tabular-nums',
                                    }}
                                >
                                    {tab.count}
                                </span>
                            ) : null}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
